module.exports = __webpack_public_path__ + "static/media/ico-radiopublic.0ae209a8.svg";